<img src="assets/img/auth/Cintra-People.svg" alt="Cintra People logo" width="320px" height="55px" />
